import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { isAdmin, isUser, isVolunteer } from "../../utils/utility";

const Header = ({ setIsMainFooter }) => {
  const navigate = useNavigate();
  const [showNavbar, setShowNavbar] = React.useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const auth = useSelector((state) => state?.auth?.tokenDetails);

  useEffect(() => {
    if (showNavbar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showNavbar]);

  useEffect(() => {
    const isFooter =
      window?.location?.pathname?.includes("/dashboard") ||
      window?.location?.pathname?.includes("/volunteer") ||
      window?.location?.pathname?.includes("/admin");
    if (isFooter) {
      setIsMainFooter(false);
    } else {
      setIsMainFooter(true);
    }
  }, [window?.location?.pathname?.length]);

  return (
    <div id="bat-header">
      <nav className="bat-header-navbar">
        <div className="bat-header-container">
          <div className="logo">
            <Link to="/">
              <img
                src="../../assets/images/bat-img/bat-logo-1.png"
                alt="BAT Logo"
              />
            </Link>
          </div>

          <div
            className={`nav-elements ${
              showNavbar ? "active" : ""
            } d-flex justify-content-center`}>
            <div className="bat-header-responsive-inner-width">
              <div className="bat-header-responsive-only mb-30">
                <div className="d-flex justify-content-end mt-30">
                  <img
                    src="./assets/images/bat-img/responsive-header-close.svg"
                    alt="BAT Logo"
                    onClick={() => setShowNavbar(false)}
                    className="cursor-pointer"
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  {!auth ? (
                    <React.Fragment>
                      <div className="bat-header-responsive-only-login-button">
                        <p
                          onClick={() => {
                            navigate("/login");
                            setShowNavbar(false);
                          }}
                          className="fw-600 text-white">
                          Login
                        </p>
                      </div>
                      <div className="bat-header-responsive-only-register-button w-100">
                        <p
                          onClick={() => {
                            navigate("/register");
                            setShowNavbar(false);
                          }}
                          className="fw-600">
                          Register
                        </p>
                      </div>
                    </React.Fragment>
                  ) : (
                    <img
                      src="./assets/images/bat-img/dashboard2.svg"
                      alt="BAT Logo"
                      style={{ width: "30px" }}
                      className="cursor-pointer"
                      onClick={() => navigate("/dashboard")}
                    />
                  )}
                </div>
              </div>
              <ul>
                <li>
                  <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>Home</NavLink>
                </li>
                <li>
                  <NavLink to="/members" className={({ isActive }) => (isActive ? 'active' : '')}>BAT Boards</NavLink>
                </li>
                <li>
                  <NavLink to="/join-bat" className={({ isActive }) => (isActive ? 'active' : '')}>Join BAT</NavLink>
                </li>
                <li>
                  <NavLink to="/bat-matrimony" className={({ isActive }) => (isActive ? 'active' : '')}>Matrimony</NavLink>
                </li>
                <li>
                  <NavLink to="/bat-events" className={({ isActive }) => (isActive ? 'active' : '')}>BAT Events</NavLink>
                </li>
                <li>
                  <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : '')}>Contact Us</NavLink>
                </li>
              </ul>
            </div>
          </div>
          {!auth ? (
            <div
              className="button login-btn cursor-pointer"
              onClick={() => navigate("/login")}>
              Login
            </div>
          ) : (
            <img
              src="/assets/images/bat-img/dashboard.svg"
              alt="BAT Logo"
              style={{ width: "30px" }}
              className="cursor-pointer"
              onClick={() => {
                if (isAdmin()) {
                  navigate("/admin");
                } else if (isVolunteer()) {
                  navigate("/volunteer");
                } else if (isUser()) {
                  navigate("/dashboard");
                }
              }}
            />
          )}
          <div className="menu-icon" onClick={handleShowNavbar}></div>
        </div>
      </nav>
      <Outlet />
    </div>
  );
};

export default Header;
